import axios from "@/api/axios"

class Api {
  constructor() {
    this.socket = null
    this.reconnectInterval = 15000
  }

  _init = async () => {
    //document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.5")

    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    tizen.tvwindow.hide(() => {}, null, "MAIN")

    _$.vue.$on("ready", () => {
      this.initSocket().then(() => (this.socket.onmessage = event => _$.handler.emit({ type: "data_received", detail: event })))
      this.tokenRequest()
    })
    return true
  }

  addListeners = () => {
    document.addEventListener("visibilitychange", _$.handler.emit, false)

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(() => __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    _$.vue.$on("device.clone", params => this.clone(params.url))
    _$.vue.$on("device.firmware", params => this.firmware(params.url))

    return true
  }
  makeConfigurations = async () => {
    webapis.systemcontrol.deleteAppPrivateInfo("OFF")
    webapis.avplay._setDisplayRects(0, 0, 1920, 1080, false)
    tizen.tvwindow.hide(() => {}, null, "MAIN")

    return true
  }
  loadResources = async () => {}
  checkOut() {
    _$.sleep(3000).then(() => __.device.reboot())
  }
  async tokenRequest(second = false) {
    if (__.device.get("tizen_token")) return

    const res = await axios()
      .post("/api/send/tizen65/token", { ip: __.device.properties.ip, mac: __.device.properties.mac })
      .catch(err => _$.error(err))

    if (!res && !second) return window.setTimeout(() => this.tokenRequest(true), 5000)
    else return res
  }
  async initSocket() {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    const { host } = _$.splitUrl(__.platform.baseUrl)
    const port = __.device.config("WSOCKET_PORT")

    const self = this
    self.socket = new WebSocket(`ws://${host}:${port}`)

    self.socket.onopen = function() {
      promise.resolve()
    }
    self.socket.onerror = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    self.socket.onclose = function() {
      setTimeout(self.connectWebSocket, self.reconnectInterval)
    }

    return promise.done
  }

  // FIRMWARE UPDATE & CLONE
  async clone(from) {
    const to = "/opt/usr/home/owner/content/Downloads"
    tizen.filesystem.listDirectory(to, list => {
      list.map(file => tizen.filesystem.deleteFile(`${to}/${file}`))

      const request = new tizen.DownloadRequest(from, to)
      tizen.download.start(request, listener)
    })

    const listener = {
      oncompleted: (id, path) => {
        try {
          webapis.clone.restoreCloneData(path)
        } catch (error) {
          console.error("Clone Restore Error [" + error.code + "]: " + error.message)
        }
      },
      onfailed: (id, error) => console.error(" Clone Download Error: " + error.name)
    }

    webapis.clone.setCloneUpdateStatusListener(data => {
      try {
        var status = JSON.parse(data)
        if (status.Result === "SUCCESS") {
          webapis.clone.unSetCloneUpdateStatusListener()
          _$.sleep(1000).then(() => __.device.reboot())
        } else if (status.Result === "FAIL") console.error(" ERROR: Cloning failed.")
      } catch (e) {
        console.error("Clone Update Status Parse Error:", e)
      }
    })
  }
  async firmware(from) {
    try {
      const infoTxtUrl = `${from}/info.txt`

      const infoTxt = await fetch(infoTxtUrl)
        .then(r => r.text())
        .catch(() => false)

      if (!infoTxt) return false

      const versionMatch = infoTxt.match(/(\d+\.\d+)/)
      if (!versionMatch) return false

      const rversion = versionMatch[1]
      const cversion = webapis.productinfo.getFirmware()

      if (cversion.includes(rversion)) return false

      const bemUrl = `${from}/swuimage.bem`

      const bemSize = await fetch(bemUrl, { method: "HEAD" })
        .then(r => parseInt(r.headers.get("Content-Length")) || 0)
        .catch(() => false)

      if (!bemSize) return false

      const bemFileName = bemUrl.split("/").pop()

      webapis.systemcontrol.updateFirmware("0", bemFileName, rversion, bemUrl, bemSize)
    } catch (err) {
      return false
    }
  }
}

export default Api
